import React from 'react';
import PropTypes from 'prop-types';

const PageSectionDivider = ({ section }) => {
  const style = {};
  if (section.style) {
    style.borderStyle = section.style;
  }
  if (section.size) {
    style.borderWidth = parseInt(section.size);
  }
  if (section.color) {
    style.borderColor = section.color;
  }

  return (
    <div className="custom-page-section page-divider">
      <hr style={style} />
    </div>
  );
};

PageSectionDivider.propTypes = {
  section: PropTypes.object.isRequired,
};

export default PageSectionDivider;
